export default __webpack_public_path__ + "static/media/snail.da971dc9.svg";